module.exports = __webpack_public_path__ + "img/addPower.428dc8ff.svg";